import "lazysizes";

import Swup from "swup";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
// import Swiper, { Autoplay, EffectFade } from "swiper";
import Swiper from "swiper/bundle";
import List from "list.js";

// import { toggleView } from "./components/toggle-view";
import { toggleDarkMode } from "./components/toggle-dark-mode";
import { toggleProject } from "./components/toggle-project";
import { toggleViewstate } from "./components/toggle-viewstate";
import { toggleInfo } from "./components/toggle-info";
import { collapsibleText } from "./components/collapsible-text";
import { floatingImages } from "./components/floating-images";
import { textPanning } from "./components/text-panning";
import { autoScrollToProject } from "./components/auto-scroll-to-project";
import Lightbox from "./components/lightbox";
// import { gallery } from "./components/gallery";


window.main = window.main || {};

let isHomepage = false;
let isProjectPage = false;
let isTouchDevice = false;
let isOverlayToggled = false;
let introRan = false;
let sliderRan = false;

let swiper;
let textPanningInstance;
let currentLightbox = null; // Track current lightbox instance
let cssSpaceBetween = getComputedStyle(
  document.documentElement
).getPropertyValue("--padding-slider");
let spaceBetween = parseInt(cssSpaceBetween, 10);

let slidesPerView = 2.3;
if (window.innerWidth < 960) {
  slidesPerView = 1.618;
}

function initSwiper() {
  const sliders = document.querySelectorAll(".js-slider");
  sliders.forEach((slider) => {
    // Count the number of slides
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    
    // Only enable loop if there are enough slides (more than 3)
    const enableLoop = slideCount > 3;
    
    const swiper = new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: spaceBetween,
      centeredSlides: false,
      centeredSlidesBounds: false,
      loop: enableLoop,
      loopedSlides: enableLoop ? 3 : 0,
      grabCursor: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      observer: true,
      speed: 800,
    });
  });
}

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

  if (document.body.classList.contains("page-project")) {
    isProjectPage = true;
  } else {
    isProjectPage = false;
  }

  if (sliderRan == true) {
    swiper.destroy();
    sliderRan = false;
  }

}

function initSortableList() {
  const projectsList = document.getElementById("projects-list");
  if (projectsList) {
    const options = { 
      valueNames: ["title", "author", "commissioner", "category", "year"],
      // Reinitialize text panning after sorting
      updated: () => {
        if (textPanningInstance && textPanningInstance.reinit) {
          setTimeout(() => textPanningInstance.reinit(), 100);
        }
      }
    };
    new List("projects-list", options);
  }
}

function setupPlugins() {
  function initSwup() {
    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main", ".js-header"],
      plugins: [
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });
  }

  initSwup();
}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function initProjectLightbox() {
  // Destroy existing lightbox if present
  if (currentLightbox) {
    currentLightbox.destroy();
    currentLightbox = null;
  }

  // Find all expanded projects (now that multiple can be open)
  const expandedProjects = document.querySelectorAll('.c-project[data-state="expanded"]');
  
  if (expandedProjects.length > 0) {
    // Create a scope that includes all expanded projects
    // This allows the lightbox to work across all open projects
    const scope = '.c-project[data-state="expanded"]';
    
    console.log('Initializing lightbox for', expandedProjects.length, 'expanded project(s)');
    
    currentLightbox = new Lightbox({
      selector: '[data-rel="aiLightbox"]',
      scope: scope,
      lazyload: true,
      arrows: true,
      counter: true,
      slideSpeed: 500,
    });
  } else {
    console.log('No expanded projects found, lightbox not initialized');
  }
}

function swupReload() {

  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  initSortableList();
  // toggleView();
  toggleDarkMode();
  toggleProject();
  toggleViewstate();
  toggleInfo();
  collapsibleText();
  textPanningInstance = textPanning();
  autoScrollToProject();
  initSwiper();
  if (!isTouchDevice) {
    floatingImages();
  }

  // Initialize project-specific lightbox
  initProjectLightbox();

}

function init() {
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  initSortableList();
  // toggleView();
  toggleDarkMode();
  toggleProject();
  toggleViewstate();
  toggleInfo();
  collapsibleText();
  textPanningInstance = textPanning();
  autoScrollToProject();
  initSwiper();
  if (!isTouchDevice) {
    floatingImages();
  }

  // Initialize project-specific lightbox
  initProjectLightbox();
  
  // Listen for project toggle events to reinitialize lightbox
  window.addEventListener('project-toggled', (event) => {
    console.log('Project toggled:', event.detail);
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      initProjectLightbox();
    }, 100);
  });

  // Listen for viewstate changes (mobile) to reinitialize text panning
  window.addEventListener('viewstate-changed', (event) => {
    console.log('Viewstate changed:', event.detail);
    // Small delay to ensure display changes are applied
    setTimeout(() => {
      if (textPanningInstance && textPanningInstance.reinit) {
        textPanningInstance.reinit();
      }
    }, 50);
  });

  function fadeOnScroll() {
    const elements = document.querySelectorAll(".js-fade-on-scroll");
    elements.forEach((element) => {
      const scrollPosition = window.scrollY;
      const opacity = 1 - scrollPosition / 100;
      element.style.opacity = opacity;
    });
  }

  window.addEventListener("scroll", fadeOnScroll);

  // function loadProjectPage(url) {
  //   const overlayContent = document.querySelector(".js-overlay-content");
  //   overlayContent.innerHTML = ""; // Clear previous content
  //   const xhr = new XMLHttpRequest();
  //   xhr.open("GET", url, true);
  //   xhr.onreadystatechange = function () {
  //     if (xhr.readyState === 4 && xhr.status === 200) {
  //       overlayContent.innerHTML = xhr.responseText;
  //       // Additional logic to initialize any JavaScript components or functionality on the loaded project page
  //     }
  //   };
  //   xhr.send();
  // }

  // function openProjectOverlay(url) {
  //   const overlay = document.querySelector(".js-overlay");
  //   overlay.classList.add("is-open");
  //   loadProjectPage(url);
  // }

  // function closeProjectOverlay() {
  //   const overlay = document.querySelector(".js-overlay");
  //   overlay.classList.remove("is-open");
  // }

  // function initProject() {
  //   // ...

  //   // Add event listener to project links
  //   const projectLinks = document.querySelectorAll(".js-project-link");
  //   projectLinks.forEach((link) => {
  //     link.addEventListener("click", (event) => {
  //       event.preventDefault();
  //       const url = link.getAttribute("href");
  //       openProjectOverlay(url);
  //     });
  //   });

  //   // Add event listener to close button
  //   const closeButton = document.querySelector(".js-overlay-close");
  //   closeButton.addEventListener("click", closeProjectOverlay);

  //   // ...
  // }

  // initProject();


}

checks();
// setupPlugins();
init();
